import RouterHolder from '@/components/router-holder'
import * as ConstantRouter from '@/constant/router'

const route = {
  path: 'mini-banners',
  name: ConstantRouter.DASHBOARD_MINI_BANNERS,
  component: RouterHolder,
  redirect: '/admin/mini-banners',
  children: [
    {
      path: '',
      component: () =>
        import(
          /* webpackChunkName: "dashboard-mini-banners" */ '@/dashboard/mini-banners'
        )
    },
    {
      path: 'add',
      name: ConstantRouter.DASHBOARD_MINI_BANNERS_ADD,
      component: () =>
        import(
          /* webpackChunkName: "dashboard-mini-banners-add" */ '@/dashboard/mini-banners/add'
        )
    },
    {
      path: 'update/:id',
      name: ConstantRouter.DASHBOARD_MINI_BANNERS_UPDATE,
      component: () =>
        import(
          /* webpackChunkName: "dashboard-mini-banners-add" */ '@/dashboard/mini-banners/add'
        )
    },
    {
      path: 'detail/:id',
      name: ConstantRouter.DASHBOARD_MINI_BANNERS_DETAIL,
      component: () =>
        import(
          /* webpackChunkName: "dashboard-mini-banners-detail" */ '@/dashboard/mini-banners/detail'
        )
    }
  ]
}

export default route
